<template lang="pug">
  main
    NavBarCotizacion
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Nueva Cotizacion&nbsp
              |
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-12.has-text-centered
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Seleccionar Bienes o Servicios para compra&nbsp
                  span.tag.is-success(v-if="itemsSeleccionados.length > 0")
                    | {{ itemsSeleccionados.length }} Seleccionado(s)
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  ListItems(:tickets_solicitudes='tickets_solicitudes' @countItems="checkItemsSel")
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Formulario Cotizaciones&nbsp
                  span.tag.is-success(v-if="Object.keys(this.formularioCot).length > 0")
                    | Completo
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  FormCotizacion(:usuarios="usuarios" @saveFormCotizacion="checkForm")
        .columns
          .column.is-12.has-text-centered
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Desglose de Bienes o Servicios&nbsp
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  ListItemsDesglose(:items="itemsSeleccionados" :baseArticulos="baseArticulos" @itemsChanged='checkItemsSaved')
        .columns
          .column.is-12
            a.button.is-black.is-rounded(@click="guardarCotizacion" :disabled="isDisabled")
              | Guardar Cotización
        .columns.column-blanco
</template>

<script>
  import NavBarCotizacion from './layout/NavBarCotizacion.vue'
  import usuariosServices from '@/services/usuarios/usuarios'
  import FormCotizacion from './componentes/FormCotizacion'
  import ListItems from './componentes/ListItems'
  import ListItemsDesglose from './componentes/ListItemsDesglose'
  import Loader from '../shared/Loader.vue'

  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  
  import InventarioServices from '../../services/inventario/inventario'
  import CotizacionesServices from '../../services/inventario/cotizaciones'
  import moment from 'moment'
  import { mapState } from 'vuex'
  var convertir = require('numero-a-letras')


  export default {
    name: 'CotizacionNueva',
    components: { Loader, NavBarCotizacion, FormCotizacion, ListItems, BulmaAccordion, BulmaAccordionItem, ListItemsDesglose },
    data() {
      return {
        isLoading: true,
        usuarios: [],
        itemsSeleccionados: [],
        itemsSaved: [],
        tickets: [],
        solicitudes: [],
        tickets_solicitudes: [],
        tickets_solicitudesSel: [],
        countItems: 0,
        formularioCot: {},
        isDisabled: false,
        formularioCot: {},
        isSaveCotizacion: false,
        itemsCot_G: 0,
        itemsCot_TS: 0,
        baseArticulos: [],
      }
    },
    watch: {
      itemsSeleccionados () {
        if (this.itemsSeleccionados.length > 0 && Object.keys(this.formularioCot).length > 0 && this.itemsSaved.length > 0) {
          this.isSaveCotizacion = true
        } else {
          this.isSaveCotizacion = false
        }
      },
      itemsSaved () {
        if (this.itemsSeleccionados.length > 0 && Object.keys(this.formularioCot).length > 0 && this.itemsSaved.length > 0) {
          this.isSaveCotizacion = true
        } else {
          this.isSaveCotizacion = false
        }
      },
      formularioCot () {
        if (this.itemsSeleccionados.length > 0 && Object.keys(this.formularioCot).length > 0 && this.itemsSaved.length > 0) {
          this.isSaveCotizacion = true
        } else {
          this.isSaveCotizacion = false
        }
      },
      isSaveCotizacion () {
        if (this.isSaveCotizacion) {
          this.isDisabled = false
        } else {
          this.isDisabled = true
          console.log('Algun formulario tiene algo faltante')
        }
      },
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },
      obtenerUsuarios () {
        usuariosServices.getUsuarios()
          .then(res => {
            if (res.length > 0) {
              const users = res.map(this.convetirUsuarios)
              this.usuarios = users.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
              this.getBaseArticulos()
            } else {
              console.log('No hay datos.')
            }
            this.isLoading = false
          })
          .catch(error=> {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
      },
      getBaseArticulos() {
        InventarioServices.getBaseArticulos()
          .then((data) => {
            this.baseArticulos = data.map(this.convertArticulo)
            this.getTickets()
          })
          .catch((error) => {
            console.error(error)
            this.isLoading = false
          })
      },
      getTickets () {
        InventarioServices.getItemsPresupuesto('P')
          .then( data => {
            this.tickets = data.map(this.convertirItems)
            this.getSolicitudes()
          })
          .catch( e => console.log(e) )
      },
      getSolicitudes() {
        InventarioServices.getSolicitudes_All()
          .then(data => {
            const solis = data.filter( sol => parseInt(sol.estado) < 4)
            this.solicitudes = solis.map(this.convertirSolicitud)
            this.getTickets_Solicitudes()
          })
          .catch(error => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`)
          })
      },
      convertArticulo (art) {
        return {
          ...art,
          text: `${art.marca} - ${art.modelo} ~ ${art.categoria} ${art.subcategoria}`
        }
      },
      convertirItems(items) {
        return {
          ...items,
          id: parseInt(items.id),
          departamento: parseInt(items.departamento),
          estado: parseInt(items.estado),
          compra: parseInt(items.compra),
          idResolucion: parseInt(items.idResolucion),
          diagnostico: parseInt(items.diagnostico),
          restante: parseInt(items.restante),
          area: parseInt(items.area),
          tipo: 1
        }
      },
      convetirUsuarios(user) {
        return {
          ...user,
          categoria: parseInt(user.categoria),
          departamento: parseInt(user.departamento),
          jefeArea: parseInt(user.jefeArea)
        }
      },
      convertirSolicitud (sol) {
        let priorConv = 0
        switch (parseInt(sol.prioridad)) {
          case 0:
            priorConv = 8
            break
          case 1:
            priorConv = 7
            break
          case 2:
            priorConv = 0
            break
        }
        return {
          ...sol,
          id: `s-${sol.id}`,
          area: parseInt(sol.area),
          cantidad: parseInt(sol.cantidad),
          departamento: parseInt(sol.departamento),
          estado: parseInt(sol.estado),
          restante: priorConv,
          tipo: 0,
          problema: sol.razon, 
          solicita: sol.oficina,
          resuelve: sol.solicita
        }

      },
      getTickets_Solicitudes () {
        this.tickets_solicitudes = this.tickets
        this.solicitudes.map(sol => this.tickets_solicitudes.push(sol))
        this.isLoading = false
      },
      checkForm(dataCot) {
        if (dataCot === 'editar') {
          // this.formularioCot = Object.assign({}, this.formularioCot, dataReq)
          this.isGetDataForm = true
          } else {
          this.formularioCot = Object.assign({}, this.formularioCot, dataCot)
          this.isGetDataForm = false
        }
      },
      guardarCotizacion() {
        if (this.isSaveCotizacion) {
          this.isLoading = true
          
          let fechaI = moment(this.periodo).startOf('month').format('YYYY-MM-DD')
          let fechaF = moment(this.periodo).endOf('month').format('YYYY-MM-DD')
          let yy = moment(this.periodo).format('YY')
          let mm = moment(this.periodo).format('MM')
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')

          CotizacionesServices.getCotizaciones_id(fechaI, fechaF)
            .then( dataId => {
              let idCot = '';
              let nombre_cot = parseInt(dataId[0].id)
              console.log(nombre_cot)
              
              switch (true) {
                case (nombre_cot >= 0) && (nombre_cot < 10):
                  idCot = `COT-${yy}${mm}-00${nombre_cot}`;
                  break
                case (nombre_cot >= 10) && (nombre_cot < 100):
                  idCot = `COT-${yy}${mm}-0${nombre_cot}`;
                  break
                case (nombre_cot >= 100):
                  idCot = `COT-${yy}${mm}-${nombre_cot}`;
                  break
                default:
                  idCot = ''
                  break;
              }

              let totalStr = convertir.NumerosALetras(this.formularioCot.totalSel)
              CotizacionesServices.addCotizacion(idCot, fechaReg, this.formularioCot.periodo, this.formularioCot.descripcion, this.formularioCot.ubicacion, this.formularioCot.concepto, this.formularioCot.tipo, this.userLogin.id, this.userLogin.nombre, this.formularioCot.monedaSel, this.formularioCot.subtotalSel,  this.formularioCot.ivaSel, this.formularioCot.totalSel, totalStr, this.formularioCot.provedorSel.id)
                .then( (rCot) => {
                  if (rCot.success) {

                    this.itemsSaved.map( (item) => {
                      CotizacionesServices.addCotizacionItemTS(rCot.getData, item.id_equipo, item.id, item.tipo, item.cantidad, item.precioUnit, item.unidadM, item.importe)
                        .then( (rTS) => {
                          if (rTS.success) {
                            this.itemsCot_TS++
                            if (this.itemsCot_TS === this.itemsSaved.length) {
                              this.formularioCot.cotizaciones.map( (cot) => {
                                CotizacionesServices.addCotizacionItem(rCot.getData, cot.proveedor.id, cot.moneda, (cot.total - cot.iva), cot.iva, cot.total, cot.file, cot.fileName)
                                  .then( (rItem) => {
                                    if (rItem.success) {
                                      this.itemsCot_G++
                                      if (this.itemsCot_G === this.formularioCot.cotizaciones.length) {
                                        this.displayToast('Se ha registrado la Cotización', 'done', 'OK')
                                        this.isLoading = false
                                        this.$router.push('/Cotizaciones')
                                      } else {
                                        console.log(`Guardados ${this.itemsCot_G} de ${this.formularioCot.cotizaciones.length}`)
                                      }
                                    } else {
                                      this.isLoading = false
                                      this.displayToast(rItem.respuesta, 'ban', 'OK')
                                    }
                                  })
                                  .catch( (e) => {
                                    this.isLoading = false
                                    this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                                  })
                              })
                            } else {
                              console.log(`Van ${this.itemsCot_TS} guardados`)
                            }
                          } else {
                            this.displayToast(rTS.respuesta, 'ban', 'OK')
                          }
                        })
                        .catch( (e) => {
                          this.isLoading = false
                          this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                        })
                    })


                    
                  } else {
                    this.isLoading = false
                    this.displayToast(rCot.respuesta, 'ban', 'Ok')
                  }
                })
                .catch( (e) => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                })
            })
            .catch( e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          console.log('No se puede hacer nada')
        }
      },
      checkItemsSel (items) {
        this.itemsSeleccionados = items
      },
      checkItemsSaved(items) {
        this.itemsSaved = []
        this.itemsSaved = items
      },
      backPage () {
        this.$router.back()
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/cotizaciones_Componentes/CotizacionNueva.vue